const _API = 'UserExpertProfiles';

export const API_USER_EXPERT_PROFILES = {
  API: _API,
  GET_ALL_DYNAMIC: `${_API}/GetAllDynamic`,
  POST: `${_API}/Create`,
  POST_VISITOR: `${_API}/CreateVisitor`,
  PATCH: ({ appIdentityUserID }: Pick<Member, 'appIdentityUserID'>) =>
    `${_API}/Patch/${appIdentityUserID}`,
  DELETE: ({ appIdentityUserID }: Pick<Member, 'appIdentityUserID'>) =>
    `${_API}/Delete/${appIdentityUserID}`,
  RESET: `${_API}/Reset`,
};

export class Member {
  id!: string;
  createdDate!: string;
  isActive: boolean = true;
  isAllowSMS: boolean = false;
  appIdentityUserID!: string;
  languageID!: string;
  generatePasswordEndDate: string = '';
  email: string = '';
  mobilePhone: string = '';
  fieldOfOccupationID = '';
  firstName: string = '';
  lastName: string = '';
  readonly fullName!: string;
  userPhoto: string = '';
  position: string = '';
  companyName: string = '';
  expertTypeID!: string | null;
  userExpertStatusID!: string | null;
}

export class Visitor {
  id!: string;
  appIdentityUserID!: string;
  email: string = '';
  mobilePhone: string = '';
  fieldOfOccupationID = '';
  firstName: string = '';
  lastName: string = '';
  readonly fullName!: string;
  userPhoto: string = '';
  position: string = '';
  companyName: string = '';
  cityID!: string | null;
  fieldOfOccupation!: string | null;
  userExpertStatusID!: string | null;
  industryID!: string | null;
}

export class VisitorModel extends Visitor {
  userExpertProfileTags!: any[];
  userExpertProfileSpeakLanguages!: any[];
}

export class Admin {
  id!: string;
  appIdentityUserID!: string;
  email: string = '';
  mobilePhone: string = '';
  fieldOfOccupationID = '';
  firstName: string = '';
  lastName: string = '';
  readonly fullName!: string;
  position: string = '';
  companyName: string = '';
  userStatusID!: string | null;
}
